import React from "react";
import { useRouter } from "next/router";
import { FaqPageContent } from "./AppTemplate";
import useDisableIntercom from "@/hooks/useDisableIntercom";
import MainTemplate from "@/components/Templates/MainTemplate";

function CommunityFaq() {
  const location = useRouter();

  const queryParser = location?.query;

  const isFromAppSource = queryParser?.source === "app";

  useDisableIntercom({ hideIntercom: isFromAppSource });

  return (
    <MainTemplate hideFooter={isFromAppSource} hideHeader={isFromAppSource}>
      <FaqPageContent webMode={!isFromAppSource} />
    </MainTemplate>
  );
}

export default CommunityFaq;
